import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import { useHistory } from "../../../../../Router";
import { isLargeScreen } from "../../../../MainViewContainer";

const QaHiringSecretLeaf = ({
  field,
  options,
  fetchOptions = () => {},
  type,
  isRecap = false,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const history = useHistory();
  const { getActiveWorkspace } = useWorkspaces();
  return isRecap ? (
    <AppText
      wrapperStyle={{
        marginLeft: 10,
        marginBottom: 10,
      }}
      style={{
        fontWeight: "bold",
      }}
    >
      {field.label}
    </AppText>
  ) : (
    <View
      style={{
        marginBottom: 20,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <AppForms.AppFormDropDown
          formFieldContainerStyle={{
            flex: 1,
          }}
          isElevated={false}
          dropDownStyle={{
            borderColor: currentTheme?.theme?.border_color,
            maxWidth: !isLargeScreen() && 250,
          }}
          showTextInputLabel
          label={field.label}
          isMandatory={field?.mandatory}
          name={field.name}
          values={field.options}
          items={[
            {
              label: "None",
              value: null,
            },
            ...options
              ?.filter((u) => u?.type == field?.subType)
              ?.map((item) => {
                return {
                  label: item?.name,
                  value: item?.id,
                };
              }),
          ]}
        />
        <View
          style={{
            marginTop: 20,
            flexDirection: "row",
            display: "flex",
            gap: 10,
            marginLeft: 10,
          }}
        >
          <AppIcon
            icon={AppAssets?.icons?.add_icon}
            isClickable
            onPress={() => {
              // open a new tab
              window.open(
                `/workspaces/${getActiveWorkspace()?.id}/settings/${type}`,
                "_blank"
              );
            }}
            size={20}
          />
          <AppIcon
            icon={AppAssets?.icons?.reload}
            isClickable
            onPress={() => {
              fetchOptions();
            }}
            size={20}
          />
        </View>
      </View>
      <AppText
        style={{
          marginLeft: 20,
        }}
        color={currentTheme?.theme?.darkGrey}
        wrapperStyle={{
          marginTop: 3,
        }}
      >
        {field.description}
      </AppText>
      <View
        style={{
          height: 1,
          backgroundColor: currentTheme?.theme?.mediumGrey,
          marginVertical: 10,
        }}
      />
    </View>
  );
};

export default QaHiringSecretLeaf;
